import { Alert, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch } from "app/hooks.ts";
import { setBypassUser } from "features/auth/authSlice.ts";
import {
  clearImpersonationStorage,
  getImpersonationState,
  getOriginalImpersonationContext,
  IMPERSONATION_TOGGLE_EVENT,
} from "features/permissions/permissionImpersonation.ts";
import { setPermissions } from "features/permissions/permissionsSlice.ts";

export const PermissionImpersonationBanner = () => {
  const dispatch = useAppDispatch();
  const [impersonationState, setImpersonationState] = useState(
    getImpersonationState,
  );

  useEffect(() => {
    const syncState = () => {
      setImpersonationState(getImpersonationState());
    };

    window.addEventListener(IMPERSONATION_TOGGLE_EVENT, syncState);
    window.addEventListener("storage", syncState);

    return () => {
      window.removeEventListener(IMPERSONATION_TOGGLE_EVENT, syncState);
      window.removeEventListener("storage", syncState);
    };
  }, []);

  if (!impersonationState) {
    return null;
  }

  const endImpersonation = () => {
    const originalContext = getOriginalImpersonationContext();

    if (originalContext) {
      dispatch(setBypassUser(originalContext.user));
      dispatch(setPermissions(originalContext.permissions));
      sessionStorage.setItem(
        "permissions",
        JSON.stringify(originalContext.permissions),
      );
    }

    clearImpersonationStorage();
  };

  return (
    <Alert
      action={
        <Button color="inherit" onClick={endImpersonation} size="small">
          End impersonation
        </Button>
      }
      severity="warning"
      sx={{
        borderRadius: 0,
        left: 0,
        position: "fixed",
        right: 0,
        top: 0,
        zIndex: 1400,
      }}
    >
      Impersonation mode enabled: {impersonationState.impersonatedUserName} (
      {impersonationState.impersonatedUserRole})
    </Alert>
  );
};

export default PermissionImpersonationBanner;
